export const Contact = () => {
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div>
        The Full Moon Art Gathering took place throughout 2023 and 2024, mostly
        in Lenapehoking aka Brooklyn, New York. This website is typeset in{" "}
        <a href="https://www.dafont.com/rainyhearts.font">Rainy Hearts</a>.
      </div>
    </div>
  );
};
